export const AEYDAR_API =
  "https://aeydarapi.netlify.app/.netlify/functions/app";

//export const AEYDAR_API = "http://localhost:9000/.netlify/functions/app";
